import { Heading as TiptapHeading } from "@knowt/editor/extensions/heading";
import { headingCollapseControlPlugin } from "./plugins/headingCollapseControlPlugin";
import { hideCollapsedNodesPlugin, splitHeading } from "./plugins/hideCollapsedNodesPlugin";

export const Heading = TiptapHeading.extend({
    addProseMirrorPlugins() {
        return [
            ...(this.parent?.() ?? []),
            headingCollapseControlPlugin(this.editor, this.name),
            hideCollapsedNodesPlugin(this.name),
        ];
    },
    addKeyboardShortcuts() {
        return {
            ...(this.parent?.() ?? {}),
            Enter: () => splitHeading(this.editor, this.type),
        };
    },
    addAttributes() {
        return {
            ...(this.parent?.() ?? {}),
            collapsed: {
                default: false,
                parseHTML: element => {
                    if (!this.editor?.isEditable) {
                        // for non owners, headers should be open by default
                        return false;
                    }

                    return element.getAttribute("collapsed") === "true";
                },
            },
        };
    },
});

export default Heading;
